// src/pages/Login/GlobalPartnerLogin.js
import React from 'react';
import Login from '../../components/Login/Login';

const GlobalPartnerLogin = () => {
  return <Login role="global-partner" />;
};

export default GlobalPartnerLogin;
